import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalComponent } from "../modal/modal.component";

@Component({
    selector: 'app-info-modal',
    templateUrl: './info-modal.component.html',
    styleUrls: ['./info-modal.component.scss']
})
export class InfoModalComponent {

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Input() title: string;
    @Input() infoMessage: string;
    @Input() actionMessage: string;
    @Input() detailsMessage: string;

    @Output() cancelInfoModal = new EventEmitter<any>();

    constructor() {
    }

    open() {
        this.modal.open();
    }

    close() {
        this.modal.close();
    }

    onCancel() {
        this.cancelInfoModal.emit();
    }
}
